import { render, staticRenderFns } from "./courseBalanceStudio.vue?vue&type=template&id=6d50b583&scoped=true&"
import script from "./courseBalanceStudio.vue?vue&type=script&lang=js&"
export * from "./courseBalanceStudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50b583",
  null
  
)

export default component.exports